import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { EditIcon } from '@components/Icons'
import appUrlLib from '@libs/appUrl'

const EditButtonContainer = styled.a`
  ${tw`bg-gray-30 text-h6 font-medium`}
  padding: 0 12px;
  height: 32px;
  color: black;
  border-radius: 24px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
`

const EditIconContainer = styled(EditIcon)`
  margin-right: 4px;
  display: block;
  width: 16px;
  height: 16px;
`

const EditButton = ({ handleOnClick }) => {
  return (
    <EditButtonContainer href={`${appUrlLib.appUrl}/user/editor`} onClick={handleOnClick}>
      <EditIconContainer src="/statics/images/profile/edit-icon.png" />
      <span>編輯</span>
    </EditButtonContainer>
  )
}

export default EditButton
